import TextCell from 'components/TextCell';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function AccountNameCell({
  rowData: { platformAccount },
}: CellProps) {
  return <TextCell text={platformAccount?.name} />;
}
